

<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-loader-modal></app-loader-modal>

<div class="modal search-location modalBackgroundNone firstpopuponload where-are-you" id="ageVerify"
  style="background: rgba(0, 0, 0, 0.6);">
  <div class="modal-dialog">
    <div class="modal-content" style="background: url(/assets/images/age-bg.jpg);width: 100%; height: 100%; border-radius: 0; position: absolute; top: 0%;
        z-index: 999;
        text-align: center;
        padding-bottom: 0 !important;
        left: auto;
        transform: none;
        box-shadow: none;
        bottom: 0;
           background-size: cover !important;
    background-repeat: no-repeat;">
        <div class="container" >
            <div class="contents">
                <div class="get-verify" style="padding: 0;">
                        <app-age-verify></app-age-verify>
                </div>
            </div>
        </div>
        </div>
  </div>
</div>
